/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_StoppedInputs */



/**
* | output |
* | --- |
* | "Stopped" |
*
* @param {Assistant_StoppedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_stopped = /** @type {((inputs?: Assistant_StoppedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_StoppedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arrêté")
	if (locale === "de") return /** @type {LocalizedString} */ ("Angehalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è fermato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Остановлено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Interrumpido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("停止")
	if (locale === "ja") return /** @type {LocalizedString} */ ("停止しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रुका हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Parou")
	return /** @type {LocalizedString} */ ("Stopped")
});